import { createFileRoute, redirect } from "@tanstack/react-router";
import { deliveryIndexRedirect } from "@/lib/staff-url-redirects";

export const Route = createFileRoute("/_protected/delivery/")({
  beforeLoad: () => {
    throw redirect(deliveryIndexRedirect());
  },
  component: () => null,
});
